module.exports = __webpack_public_path__ + "static/assets/a42b5a072afdc2d1aa55accfb1168fb3.mp3";